class RequestorHelperService {
    buildPresentationRequest (slideRequestFunc, filename, data, title, subtitle, settings) {
        let pptRequest = { ResponseFileName: filename, SlideRequests: [] };

        if (slideRequestFunc && data) {
            let slideRequest = slideRequestFunc(data, title, subtitle, settings);

            if (Array.isArray(slideRequest)) {
                slideRequest.forEach(sr => {
                    pptRequest.SlideRequests.push(sr);
                });
            } else {
                pptRequest.SlideRequests.push(slideRequest);
            }
        }

        return pptRequest;
    }
}

export const requestorHelperService = new RequestorHelperService();
